import React from 'react';
import { OCCUPATIONS, PROFESSIONS } from "../../../constants/formData";

const EducationCareerSection = ({ isEditing, getValue, onDataChange, editingFields }) => {
  const allProfessions = Object.values(PROFESSIONS).flat();
  const incomeLabels = {
  "0-25000": "$0 - $25,000",
  "25000-50000": "$25,000 - $50,000",
  "50000-75000": "$50,000 - $75,000",
  "75000-100000": "$75,000 - $100,000",
  "100000-150000": "$100,000 - $150,000",
  "150000-200000": "$150,000 - $200,000",
  "200000+": "$200,000+",
};

  return (
    <div className="row py-3 border-top">
      <div className="col-md-6 pe-md-4">
        <table className="table table-borderless table-sm mini-data mb-0">
          <tbody>
            <tr>
              <td>Highest Qualification:</td>
              <td>{isEditing && editingFields === "career" ? (
                <input
                  type="text"
                  value={getValue('education') || ''}
                  onChange={(e) => onDataChange('education', e.target.value)}
                  className="form-control form-control-sm d-inline-block w-75"
                />
              ) : (
                getValue('education')
              )}</td>
            </tr>
            <tr>
              <td>College:</td>
              <td>{isEditing && editingFields === "career" ? (
                <input
                  type="text"
                  value={getValue('college') || ''}
                  onChange={(e) => onDataChange('college', e.target.value)}
                  className="form-control form-control-sm d-inline-block w-75"
                />
              ) : (
                getValue('college')
              )}</td>
            </tr>
           <tr>
  <td>Annual Income:</td>
  <td>
    {isEditing && editingFields === "career" ? (
      <select
        value={getValue("income") || ""}
        onChange={(e) => onDataChange("income", e.target.value)}
        className="form-select form-select-sm d-inline-block w-75"
      >
        <option value="">Select Income</option>

        <option value="0-25000">$0 - $25,000</option>
        <option value="25000-50000">$25,000 - $50,000</option>
        <option value="50000-75000">$50,000 - $75,000</option>
        <option value="75000-100000">$75,000 - $100,000</option>
        <option value="100000-150000">$100,000 - $150,000</option>
        <option value="150000-200000">$150,000 - $200,000</option>
        <option value="200000+">Above $200,000</option>
      </select>
    ) : (
     <>{incomeLabels[getValue("income")] || ""}</>
    )}
  </td>
</tr>
          </tbody>
        </table>
      </div>
      <div className="col-md-6 border-start ps-md-4 mt-4 mt-md-0">
        <table className="table table-borderless table-sm mini-data mb-0">
          <tbody>
            <tr>
              <td>Working With:</td>
              <td>{isEditing && editingFields === "career" ? (
                <select
                  value={getValue('work_type') || ''}
                  onChange={(e) => onDataChange('work_type', e.target.value)}
                  className="form-select form-select-sm d-inline-block w-75"
                >
                  <option value="">Select</option>
                  {OCCUPATIONS.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              ) : (
                getValue('work_type')
              )}</td>
            </tr>
            <tr>
              <td>Working as:</td>
              <td>{isEditing && editingFields === "career" ? (
                <select
                  value={getValue('profession') || ''}
                  onChange={(e) => onDataChange('profession', e.target.value)}
                  className="form-select form-select-sm d-inline-block w-75"
                >
                  <option value="">Select</option>
                  {allProfessions.map((item) => (
                    <option key={item.value} value={item.value}>{item.label}</option>
                  ))}
                </select>
              ) : (
                getValue('profession')
              )}</td>
            </tr>
            <tr>
              <td>Employer Name:</td>
              <td>{isEditing && editingFields === "career" ? (
                <input
                  type="text"
                  value={getValue('employer') || ''}
                  onChange={(e) => onDataChange('employer', e.target.value)}
                  className="form-control form-control-sm d-inline-block w-75"
                />
              ) : (
                getValue('employer') || '------'
              )}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EducationCareerSection;